import axios from 'axios';
import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useEffect, useState, useMemo } from 'react';
import { ModalDesigner } from '../../../../../../src/components/ModalDesigner/index';
import { LinkAccountB3 } from '../../../../components/Dashboard/Settings/LinkAccountB3';
import { InputComponent } from '../../../../../components/InputComponent';
import { Brokerages } from '../../components/Brokerages/intex';
import ModalCriarBox from './Box/index';
import RendaFixaInfo from './infoRendaFixa/index';

import {
  ManualImportContainer,
  ContentTable,
  ContentFrame,
  Card,
  Box,
} from './styles';
import { IPropsPositionAll } from '../../../../../utils/@types/wallet';
import { IPropsMattress } from '../../../../components/Boltz/MyWallet/Mattress/@types';
import { financeRoutes } from '../../../../../utils/RoutesApi';
import { baseURL } from '../../../../../utils/baseURL';
import { TableSelectedMattress } from '../../../../components/Boltz/MyWallet/Mattress/components/TableSelectedMattress';
import { useTitleAndUser } from '../../../../../../src/hooks/userTitle';
import {
  DotsThreeVertical,
  Plus,
  HandCoins,
  Car,
  HouseLine,
  AirplaneTilt,
  Wrench,
  Student,
  Tag,
  HandHeart,
  ChartLineUp,
  PiggyBank,
  Briefcase,
  DeviceMobile,
  DesktopTower,
  Heartbeat,
  PawPrint,
  UserCircle,
  Medal,
  PlayCircle,
  GraduationCap,
  PlusCircle,
  ShieldPlus,
} from '@phosphor-icons/react';
import pasta from '../EmergenceReserve/src/pasta.svg';
import moeda from '../EmergenceReserve/src/moeda.svg';
import checkin from '../EmergenceReserve/src/CheckCircleGreen.svg';
import nocheck from '../EmergenceReserve/src/Circle.svg';
import art from '../EmergenceReserve/src/Art.svg';
import graph from '../EmergenceReserve/src/Graph.png';
import group from '../EmergenceReserve/src/Group 8.svg';
import logoIBOX from '../../../../../assets/Logo icon.svg';
import { MoneyCollectFilled, TagOutlined } from '@ant-design/icons';
import { DividendInformationCol } from '../../../Business/components/DividendInformation/styles';
import { Content } from 'antd/es/layout/layout';
import data from '../../../../components/bootstrap/alertData';
import Item from 'antd/es/list/Item';

const header = [
  { label: 'Ativo', active: 'tickerSymbol' },
  { label: 'Remover/Adicionar' },

  { label: 'Total', active: 'updateValue' },
];

interface ObjetivoTemplate {
  label: string;
  iconName: string;
}

export interface IPropsAllPosition extends IPropsPositionAll {
  key: string;
}

type ObjectiveRef = {
  id: string;
  name: string;
  icon: string;
};

type PositionWithObjectives = IPropsAllPosition & {
  objectives: ObjectiveRef[];
};

interface EmergenceReserveProps {
  setTab: React.Dispatch<React.SetStateAction<number>>;
  setScreens: React.Dispatch<
    React.SetStateAction<'wallet' | 'strategy' | 'simulators'>
  >;
}

export function EmergenceReserve({
  setTab,
  setScreens,
}: EmergenceReserveProps) {
  const [totalPatrimonio, setTotalPatrimonio] = useState(0);
  const [filterTextSearchActive, setFilterTextSearchActive] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [dataAllActive, setDataAllActive] = useState<IPropsAllPosition[]>([]);
  const [modalLinkAccountB3, setModalLinkAccountB3] = useState(false);
  const [objetivos, setObjetivos] = useState<any[]>([]);

  const [showInfo, setShowInfo] = useState(false);
  const [showModalObjetivos, setShowModalObjetivos] = useState(false);
  const [showModalCriarBox, setShowModalCriarBox] = useState(false);
  const [editingBox, setEditingBox] = useState(null);
  const [showFloatingVideo, setShowFloatingVideo] = useState(false);
  const [objetivoSelecionado, setObjetivoSelecionado] =
    useState<ObjetivoTemplate | null>(null);
  const [expirationDate, setExpirationDate] = useState<string | null>(null);

  // @ts-ignore
  const { user } = useTitleAndUser();
  const objectivesByTicker = useMemo(() => {
    const map: Record<string, ObjectiveRef[]> = {};

    if (!Array.isArray(objetivos)) return map;

    objetivos.forEach((box: any) => {
      box.investments?.forEach((inv: any) => {
        const ticker = inv.position?.tickerSymbol;
        if (!ticker) return;

        if (!map[ticker]) map[ticker] = [];

        // Um ticker pode ter vários lançamentos (lotes/compras) dentro da
        // mesma box — sem essa checagem, cada lançamento soma um ícone
        // repetido do mesmo objetivo na coluna "Objetivo".
        const alreadyLinked = map[ticker].some((obj) => obj.id === box.id);
        if (alreadyLinked) return;

        map[ticker].push({
          id: box.id,
          name: box.name,
          icon: box.icon,
        });
      });
    });
    return map;
  }, [objetivos]);

  const totalCategoriaInvestimentos = useMemo(() => {
    if (!Array.isArray(dataAllActive)) return 0;

    return dataAllActive.reduce((acc, item) => {
      const manual = Number(item.manual_update_value || 0);
      const valorAtualizado = Number(item.updateValue || 0);
      const valorEmBox = Number(item.total_investment_box_applied_value || 0);

      const valorTotalAtivo = manual > 0 ? manual : valorAtualizado + valorEmBox;
      const valorNaoAlocado = valorTotalAtivo - valorEmBox;

      return acc + Math.max(valorNaoAlocado, 0);
    }, 0);
  }, [dataAllActive]);

  const totalObjetivos = useMemo(() => {
    if (!Array.isArray(objetivos)) return 0;

    return objetivos.reduce((acc, item) => {
      const valorAplicado = Number(item.total_applied_value || 0);
      return acc + valorAplicado;
    }, 0);
  }, [objetivos]);

  async function getActives() {
    let arrMattress: IPropsMattress[] = [];
    await axios
      .get(`${baseURL}${financeRoutes.FINANCE_POSITION}`, {
        params: { show_reserve: true },
      })
      .then((response) => {
        let newData: IPropsAllPosition[] = response.data.positionsAll;
        let totalReduce = response.data.positionsAll.filter(
          //@ts-ignore
          (item) => item.reservadeemergencia
        );
        //@ts-ignore

        for (var mattress in arrMattress) {
          newData.map((item) => {
            if (item.tickerSymbol === arrMattress[mattress].ativo) {
              item.key = arrMattress[mattress].key;
            }
            return item;
          });
        }
        newData = newData.filter(
          (item) =>
            item.productTypeName === 'tesourodireto' ||
            item.productTypeName === 'rendafixa'
        );
        // const patrimonio = newData.reduce((acc, item: any) => {
        //   const investmentValue = item.manual_update_value || item.updateValue || 0;
        //   const boxValue = item.total_investment_box_applied_value || 0;
        //   return acc + investmentValue + boxValue;
        // }, 0);

        const patrimonio = calcularPatrimonioRendaFixa(newData);
        setTotalPatrimonio(patrimonio);
        setDataAllActive(newData);
      })
      .catch((err) => {});
  }

  function calcularPatrimonioRendaFixa(
    positions: IPropsAllPosition[]
      ): number {
        return positions.reduce((acc, item) => {
          const manual = Number(item.manual_update_value || 0);
          const bruto = Number(item.updateValue || 0) +
                        Number(item.total_investment_box_applied_value || 0);

          const valorFinal = manual > 0 ? manual : bruto;

          return acc + valorFinal;
        }, 0);
      }

  
  function handleUpdateMattress(id: string) {
    const newState = dataAllActive.map((item) => {
      if (item.tickerSymbol === id) {
        return {
          ...item,
          reservadeemergencia: !item.reservadeemergencia,
        };
      }
      return item;
    });

    setDataAllActive(newState);
  }

  const ArrayFilteredAllTabe = dataAllActive?.filter((item) => {
    if (
      item.tickerSymbol
        .toLowerCase()
        .includes(filterTextSearchActive.toLocaleLowerCase()) ||
      item.corporationName
        .toLowerCase()
        .includes(filterTextSearchActive.toLocaleLowerCase())
    ) {
      return item;
    }
  });

  const dataWithObjectives: PositionWithObjectives[] = ArrayFilteredAllTabe.map(
    (item) => ({
      ...item,
      objectives: objectivesByTicker[item.tickerSymbol] ?? [],
    })
  );

  function formatarData(dataIso: string) {
    const meses = [
      'Janeiro',
      'Fevereiro',
      'Março',
      'Abril',
      'Maio',
      'Junho',
      'Julho',
      'Agosto',
      'Setembro',
      'Outubro',
      'Novembro',
      'Dezembro',
    ];

    const data = new Date(dataIso);
    const mes = meses[data.getMonth()];
    const ano = data.getFullYear();

    return `${mes} de ${ano}`;
  }

  const objetivosTemplate = [
    { label: 'Novo objetivo', iconName: 'plus' },
    { label: 'Reserva de emergência', iconName: 'money' },
    { label: 'Novo carro', iconName: 'car' },
    { label: 'Nova casa', iconName: 'house' },
    { label: 'Nova viagem', iconName: 'airplane' },
    { label: 'Nova reforma', iconName: 'wrench' },
    { label: 'Educação', iconName: 'student' },
    { label: 'Novo sonho de consumo', iconName: 'tag' },
    { label: 'Casamento', iconName: 'ring' },
    { label: 'Aposentadoria', iconName: 'retirement' },
    { label: 'Impostos/Taxas', iconName: 'chart' },
    { label: 'Novo negócio', iconName: 'briefcase' },
    { label: 'Smartphone novo', iconName: 'phone' },
    { label: 'Computador novo', iconName: 'computer' },
    { label: 'Saúde', iconName: 'health' },
    { label: 'Pets', iconName: 'pet' },
  ];

  const icons = [
    {
      name: 'plus',
      element: <ShieldPlus size={24} width="44" height="44" fill="#EC6643" />,
    },
    {
      name: 'money',
      element: <PiggyBank size={24} width="44" height="44" fill="#EC6643" />,
    },
    {
      name: 'car',
      element: <Car size={24} width="44" height="44" fill="#EC6643" />,
    },
    {
      name: 'house',
      element: <HouseLine size={24} width="44" height="44" fill="#EC6643" />,
    },
    {
      name: 'airplane',
      element: <AirplaneTilt size={24} width="44" height="44" fill="#EC6643" />,
    },
    {
      name: 'wrench',
      element: <Wrench size={24} width="44" height="44" fill="#EC6643" />,
    },
    {
      name: 'student',
      element: <Student size={24} width="44" height="44" fill="#EC6643" />,
    },
    {
      name: 'tag',
      element: <Tag size={24} width="44" height="44" fill="#EC6643" />,
    },
    {
      name: 'ring',
      element: <HandHeart size={24} width="44" height="44" fill="#EC6643" />,
    },
    {
      name: 'retirement',
      element: <UserCircle size={24} width="44" height="44" fill="#EC6643" />,
    },
    {
      name: 'chart',
      element: <HandCoins size={24} width="44" height="44" fill="#EC6643" />,
    },
    {
      name: 'briefcase',
      element: <Briefcase size={24} width="44" height="44" fill="#EC6643" />,
    },
    {
      name: 'phone',
      element: <DeviceMobile size={24} width="44" height="44" fill="#EC6643" />,
    },
    {
      name: 'computer',
      element: <DesktopTower size={24} width="44" height="44" fill="#EC6643" />,
    },
    {
      name: 'health',
      element: <Heartbeat size={24} width="44" height="44" fill="#EC6643" />,
    },
    {
      name: 'pet',
      element: <PawPrint size={24} width="44" height="44" fill="#EC6643" />,
    },
  ];

  function getIcon(name: string) {
    return icons.find((i) => i.name === name)?.element || null;
  }

  async function fetchObjetivos() {
    try {
      const res = await axios.get(
        `${baseURL}${financeRoutes.FINANCE_BOX_LIST}`
      );
      setObjetivos(res.data);
      // console.log('buscar dados box', res.data);
    } catch (err) {
      console.log('Erro ao buscar objetivos:', err);
    }
  }

  useEffect(() => {
    if (!showModalCriarBox) {
      fetchObjetivos();
      getActives();
    }
  }, [showModalCriarBox]);

  useEffect(() => {
    getActives();
  }, []);

  useEffect(() => {
    if (!dataAllActive || dataAllActive.length === 0) return;

    const rendaFixa = dataAllActive.filter((item: any) =>
      ['tesourodireto', 'rendafixa'].includes(item.productTypeName)
    );

    if (rendaFixa.length === 0) {
      setExpirationDate('—');
      return;
    }

    const ultimaData = rendaFixa
      .map((item: any) => new Date(item.expirationDate))
      .sort((a: Date, b: Date) => b.getTime() - a.getTime())[0];

    const dataFormatada = ultimaData.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });

    setExpirationDate(dataFormatada);
  }, [dataAllActive]);

  function ObjetivoBox({ item }: any) {
    const progresso = item.total_objective_value > 0
      ? Math.min(item.total_applied_value / item.total_objective_value, 1)
      : 0;
    return (
      <div className="box-item">
        <div className="icon-area">
          <div className="icons-box">
            <div className="icon">{getIcon(item.icon)}</div>

            <div
              className="icon2"
              onClick={() => {
                setEditingBox(item);
                setShowModalCriarBox(true);
              }}
              style={{
                borderRadius: '50px',
                backgroundColor: '#f1efefff',
                cursor: 'pointer',
                height: '40px',
                width: '40px',
              }}
            >
              <DotsThreeVertical size={24} color="#6A717E" />
            </div>
          </div>
          <div className="box-header">
            <h5 className="title-box">{item.name}</h5>
            <p className="descricao">{formatarData(item.created_at)}</p>
          </div>
        </div>

        <div className="info">
          <div className="info-box">
            <div className="info-numbers">
              <span className="info-valor">valor conquistado</span>
              <span className="info-aplicado">
                R$ {item.total_applied_value.toLocaleString('pt-BR')}
              </span>
            </div>
            {/* BARRA DE PROGRESSO */}
            <div className="progress-bar-container">
              <div
                className="progress-bar-fill"
                style={{ width: `${progresso * 100}%` }}
              >
                <div className="progress-handle">
                  <Medal fill="white" />
                </div>
              </div>
            </div>
            <div className="info-meta">
              <span className="de">de </span>
              <span className="info-valor-meta">
                R$ {item.total_objective_value.toLocaleString('pt-BR')}
              </span>
            </div>
          </div>

          <div className="renda-fixa">
            {item.investments?.slice(0, 3).map((inv: any) => (
              <div key={inv.investment_id} className="ticker-item">
                <span className="ticker-name">
                  • {inv.position?.tickerSymbol ?? 'Sem ticker'}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  if (showInfo) {
    return <RendaFixaInfo onBack={() => setShowInfo(false)} />;
  }

  return (
    <ManualImportContainer>
      {dataAllActive.length === 0 ? (
        <div className="empty-state">
          <h2>Minha Renda Fixa</h2>
          <h4>
            {user?.Name?.split(' ')[0]}, comece agora a organizar seus sonhos!
          </h4>
          <p className="p">
            Você ainda não tem ativos de Renda Fixa cadastrados, mas isso não te
            impede de começar a planejar.
          </p>
          <div className="infoPasso">
            <div className="steps-box">
              <h3>Passo a passo</h3>
              <ul className="textPasso">
                <li>
                  <img alt='Check' src={checkin} />
                  <strong>Sonhe grande:</strong> identifique os objetivos que
                  você deseja realizar.
                </li>
                <li>
                  <img alt='Check' src={nocheck} />
                  <strong>Organize seus investimentos:</strong> lance
                  manualmente ou conecte seus ativos de Renda Fixa com a B3.
                </li>
                <li>
                  <img alt='Check' src={nocheck} />
                  <strong>Crie seus objetivos:</strong> defina metas com prazos
                  e valores para cada conquista que deseja alcançar.
                </li>
              </ul>
            </div>

            <aside className="video-box">
              <li className="tituloVideo">Assista ao vídeo</li>
              <span>Aprenda a usar a área de Renda Fixa do iBox6</span>
              <button
                className="btn-video"
                onClick={() => setShowFloatingVideo(true)}
              >
                <PlayCircle color="#EC6643" width="20" height="20" />{' '}
                Assistir vídeo
              </button>
            </aside>
          </div>
          <div className="contentButtons">
            <p className="comeceJa">Comece já!</p>
            <div className="buttonArea">
              <div className="containerbutton">
                <img src={pasta} alt="Pasta" className="svg" />
                <div className="text">
                  <p className="tituloButton">Lance ativos</p>
                  <p className="paragrafoButton">
                    Adicione seus investimentos em Renda Fixa de forma simples e
                    rápida, informando os dados principais como nome do título,
                    valor aplicado e data de vencimento — ideal para quem ainda
                    não conectou a carteira com a B3.
                  </p>
                </div>
                <button
                  className="button"
                  onClick={() => {
                    setShowModal(true);
                  }}
                >
                  Lançar Ativos
                </button>
              </div>
              {showModal && (
                <div
                  className="modal-overlay"
                  onClick={() => setShowModal(false)}
                >
                  <div
                    className="modal-content"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <header className="modal-header">
                      <h3>Importar ativos de Renda Fixa</h3>
                      <button
                        className="close"
                        onClick={() => setShowModal(false)}
                      >
                        ×
                      </button>
                    </header>
                    <div className="modal-body">
                      <p className="text-modal">
                        Conecte seus dados ou insira seus ativos manualmente e
                        comece a visualizar sua jornada financeira com clareza.
                      </p>
                      <div className="actions">
                        <button
                          className="button"
                          onClick={() => {
                            setScreens('wallet');
                            setTab(5);
                          }}
                        >
                          Lançar manualmente
                        </button>
                        <button
                          className="button2"
                          onClick={() => {
                            setShowModal(false);
                            setModalLinkAccountB3(true);
                          }}
                        >
                          Conectar com a B3
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <ModalDesigner
                id="linkModal"
                isOpen={modalLinkAccountB3}
                setState={setModalLinkAccountB3}
                title="Vincular conta B3"
                size="sm"
              >
                <LinkAccountB3 onCloseModal={setModalLinkAccountB3} />
              </ModalDesigner>

              <div className="containerbutton">
                <img
                  src={moeda}
                  alt="Moeda"
                  className="svg"
                  style={{ width: '62.602px', height: '61.083px' }}
                />
                <div className="text">
                  <p className="tituloButton">Saiba mais sobre Renda Fixa</p>
                  <p className="paragrafoButton">
                    Entenda como investir com segurança, previsibilidade e
                    rendimento estável. Descubra os principais tipos de ativos e
                    como eles podem ajudar você a conquistar seus objetivos
                    financeiros.
                  </p>
                </div>
                <button className="button" onClick={() => setShowInfo(true)}>
                  Saiba mais sobre Renda Fixa
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <ContentTable>
          <ContentFrame>
            <div className="containerTable">
              <div className="tituloRendaFixa">Minha Renda Fixa</div>
              <button onClick={() => setShowInfo(true)} className="buttonTable">
                <GraduationCap size={18} /> Saiba mais
              </button>
            </div>
            <div style={{ display: 'flex', gap: '32px', flexWrap: 'wrap' }}>
              <Card>
                <p className="p" style={{ display: 'flex', flex:'row', justifyContent:'space-between' }}>
                  Patrimônio total investido
                  <Tooltip title="Mostra o valor total que você possui atualmente em investimentos de renda fixa, considerando todos os ativos cadastrados na plataforma.">
                    <InfoCircleOutlined style={{ color: '#EC6643', cursor: 'pointer', width:'12px', height:'12px' }} />
                  </Tooltip>
                </p>
                <div className="cardPatrimonio">
                  <div className="numberInfo">
                    <h3>
                      {totalPatrimonio.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      })}
                    </h3>
                  </div>

                  <img
                    src={art}
                    alt="Patrimônio total investido"
                    className="svg"
                    style={{ width: '62px', height: '40px' }}
                  />
                </div>
              </Card>


              <Card>
                <p className="p" style={{ display: 'flex', flex:'row', justifyContent:'space-between' }}>
                  Investimentos de Renda Fixa
                  <Tooltip title="Representa o valor dos investimentos de renda fixa que ainda não foram vinculados a nenhuma caixinha de objetivo. É o saldo disponível para alocar em novos objetivos.">
                    <InfoCircleOutlined style={{ color: '#EC6643', cursor: 'pointer', width:'12px', height:'12px' }} />
                  </Tooltip>
                </p>

                <div className="cardPatrimonio">
                  <div className="numberInfo">
                    <h3>
                      {totalCategoriaInvestimentos.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      })}
                    </h3>
                  </div>

                  <img
                    src={graph}
                    alt="Investimentos de Renda Fixa"
                    className="svg"
                    style={{ width: '62px', height: '40px' }}
                  />
                </div>
              </Card>


              <Card>
                <p className="p" style={{ display: 'flex', flex:'row', justifyContent:'space-between' }}>
                  Renda Fixa alocada em objetivos
                  <Tooltip title="Mostra o valor total que você já acumulou somando todas as caixinhas de objetivos criadas.">
                    <InfoCircleOutlined
                      style={{ color: '#EC6643', cursor: 'pointer', width: '12px', height: '12px' }}
                    />
                  </Tooltip>
                </p>

                <div className="cardPatrimonio">
                  <div className="numberInfo">
                    <h3>
                      {totalObjetivos.toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      })}
                    </h3>
                  </div>

                  <img
                    src={group}
                    alt="Renda Fixa alocada em objetivos"
                    className="svg"
                    style={{ width: '62px', height: '40px' }}
                  />
                </div>
              </Card>
            </div>
          </ContentFrame>

          <Box>
            <div className="box">
              <div>
                <div className="box-objetivos">Box de objetivos</div>
                <img src={logoIBOX} alt="logo" className="svg" />
              </div>

              <button
                className="buttonBox"
                onClick={() => setShowModalObjetivos(true)}
              >
                <PlusCircle size={18} /> Criar box de objetivos
              </button>
            </div>
            {showModalObjetivos && (
              <div
                className="modal-overlay"
                onClick={() => setShowModalObjetivos(false)}
              >
                <div
                  className="modal-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <header className="modal-header">
                    <h3>Novo objetivo</h3>
                    <button
                      className="close"
                      onClick={() => setShowModalObjetivos(false)}
                    >
                      ×
                    </button>
                  </header>

                  <div className="modal-body objetivos-modal">
                    <div className="objetivos-grid">
                      {objetivosTemplate.map((item, i) => (
                        <div
                          key={i}
                          className={`objetivo-card ${
                            objetivoSelecionado?.label === item.label
                              ? 'selected'
                              : ''
                          }`}
                          onClick={() => {
                            setObjetivoSelecionado(item);
                            setShowModalObjetivos(false);
                            setShowModalCriarBox(true);
                          }}
                        >
                          {getIcon(item.iconName)}
                          <p className="tituloObjetivo">{item.label}</p>
                        </div>
                      ))}
                    </div>
                  </div>

                  <footer className="modal-footer">
                    <button
                      className="button2"
                      onClick={() => setShowModalObjetivos(false)}
                    >
                      Cancelar
                    </button>
                    <button
                      className="button"
                      onClick={() => {
                        setShowModalObjetivos(false);
                        setShowModalCriarBox(true);
                      }}
                    >
                      Próximo
                    </button>
                  </footer>
                </div>
              </div>
            )}

            {showModalCriarBox && (
              <ModalCriarBox
                visible={showModalCriarBox}
                onClose={() => {
                  setShowModalCriarBox(false);
                  setEditingBox(null);
                }}
                editingBox={editingBox}
                selectedObjective={objetivoSelecionado}
                // onCreate={(novo) => {
                //   console.log("Novo box criado:", novo);
                //   setShowModalCriarBox(false);
                // }}
              />
            )}
            <div className="aviso">
              <strong>Atenção</strong>
              <p>
                A nossa visualização de rendimentos listados abaixo não geram
                rendimentos por si só. São apenas de caráter de visualização de
                dados de seus ativos vinculados à B3.
              </p>
            </div>
            <div className="boxes-container">
              {Array.isArray(objetivos) && objetivos.length > 0 &&
                objetivos.map((item: any) => {
                  return <ObjetivoBox key={item.id} item={item} />;
                })}

              <div
                className="box-item criar-novo"
                onClick={() => setShowModalObjetivos(true)}
              >
                <PlusCircle size={24} width="44" height="44" fill="#EC6643" />
                <p>Criar nova box</p>
                <p className="textBox">
                  Clique aqui para criar um novo objetivo e alcançar mais uma
                  conquista para sua vida
                </p>
              </div>
            </div>
          </Box>

          <header>
            <span className="tituloRendaFixa">Meus ativos</span>
            <button
                className="btn-video"
                onClick={() => setShowFloatingVideo(true)}
              >
                <PlayCircle color="#EC6643" width="20" height="20" />{' '}
                Assistir tutorial
              </button>
          </header>
          <TableSelectedMattress
            ASC={(newValue: IPropsAllPosition[]) => {
              setDataAllActive(newValue);
            }}
            DESC={(newValue: IPropsAllPosition[]) => {
              setDataAllActive(newValue);
            }}
            header={[
              { label: 'Objetivo', active: 'tickerSymbol' },
              { label: 'Título', active: 'tickerSymbol' },
              { label: 'Categoria', active: 'corporationName' },
              { label: 'Valor Aplicado', active: 'closingPrice' },
              { label: 'Valor Atualizado', active: 'updateValue' },
              { label: 'Vencimento', active: 'bookkeeperName' },
              { label: 'Ações', active: 'bookkeeperName' },
            ]}
            dataTable={dataWithObjectives}
            // dataTable={ArrayFilteredAllTabe}
            onSubmitUpdateMattress={(id) => handleUpdateMattress(id)}
            handleUpdate={getActives}
            onBoxRefresh={fetchObjetivos}
          />

        </ContentTable>
      )}
                {showFloatingVideo && (
            <div className="floating-video">
              <button
                className="close-video"
                onClick={() => setShowFloatingVideo(false)}
              >
                ✕
              </button>

              <iframe
                id="panda-a1783977-bd4b-4090-9519-abec5acc8d84"
                src="https://player-vz-447732c4-8c0.tv.pandavideo.com.br/embed/?v=a1783977-bd4b-4090-9519-abec5acc8d84"
                frameBorder="0"
                allow="autoplay; fullscreen"
                allowFullScreen
              />
            </div>
          )}
    </ManualImportContainer>
  );
}
